import { atlasRoutes } from "@/app/router/routes";
import { LookupByUuidForm } from "@/components/forms/lookup-by-uuid-form";
import { FC } from "react";
import { useNavigate } from "react-router";

export const DataImportsRootPage: FC = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h1>Data Imports</h1>

      <LookupByUuidForm
        onSubmit={uuid =>
          navigate(atlasRoutes.dataImportsView({ params: { dataImportId: uuid } }).path)
        }
      />
    </div>
  );
};
